import React, { createContext, useContext, useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "./UserContext";

const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  const { user } = useUser();
  const [invoices, setInvoices] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  // on-mount & whenever the user changes, fetch invoices + templates
  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      // console.log("fetching invoice");
      setLoading(true);
      try {
        const invoiceQ = query(
          collection(db, "invoices"),
          where("createdBy", "==", user.uid)
        );
        const templateQ = query(
          collection(db, "invoiceTemplates"),
          where("createdBy", "==", user.uid)
        );

        const [invSnap, tplSnap] = await Promise.all([
          getDocs(invoiceQ),
          getDocs(templateQ),
        ]);

        setInvoices(invSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setTemplates(tplSnap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error("Error fetching invoices/templates:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user, setInvoices, setTemplates]);

  return (
    <InvoiceContext.Provider
      value={{
        invoices,
        setInvoices,
        templates,
        setTemplates,
        loading,
        setLoading,
      }}
    >
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoiceContext = () => useContext(InvoiceContext);
